import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-validation-row',
    imports: [MatIcon],
    templateUrl: './validation-row.component.html',
    styleUrl: './validation-row.component.scss'
})
export class ValidationRowComponent {
  /** The validation text (required) */
  validationText = input<string>();

  /** Whether the item passes validation (required) */
  passesValidation = input<boolean>();
}
